import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const RestartIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <g>
                <path fill="currentColor" d="M12.375,22.5c-0.414,0-0.75-0.336-0.75-0.75S11.961,21,12.375,21C17.131,21,21,17.131,21,12.375S17.131,3.75,12.375,3.75S3.75,7.619,3.75,12.375c0,3.135,1.604,5.963,4.085,7.204c0.371,0.186,0.521,0.636,0.336,1.006s-0.634,0.521-1.006,0.335c-2.986-1.493-4.915-4.847-4.915-8.546C2.25,6.792,6.792,2.25,12.375,2.25S22.5,6.792,22.5,12.375S17.958,22.5,12.375,22.5z"/>
            </g>
            <g>
                <path fill="currentColor" d="M8.25,22h-4.5C3.336,22,3,21.664,3,21.25s0.336-0.75,0.75-0.75H7.5v-3.75C7.5,16.336,7.836,16,8.25,16S9,16.336,9,16.75v4.5C9,21.664,8.664,22,8.25,22z"/>
            </g>
            <g>
                <path fill="currentColor" d="M12.375,7.5C9.75,7.5,8.25,9.014,8.25,11.284c0,2.653,3.168,5.887,3.952,6.646c0.097,0.094,0.25,0.094,0.347,0c0.783-0.759,3.952-3.993,3.952-6.646C16.5,9.392,15,7.5,12.375,7.5z M12.375,13.5c-1.036,0-1.875-0.839-1.875-1.875c0-1.036,0.839-1.875,1.875-1.875s1.875,0.839,1.875,1.875C14.25,12.661,13.411,13.5,12.375,13.5z"/>
            </g>
        </SvgIcon>
    );
};